import styled from 'styled-components';

export const Style = styled.div`
  disply: flex;
  width: 100%;
  flex-direction: column;

  .tabs-cont {
    background: #FFFFFF; 
    // border-radius: 4px;
    padding: 12px var(--size-lg) var(--size-lg) var(--size-lg);
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
    margin-top: var(--size-lg);

    .widget {
      border: 1px solid #EAECF0;
      box-shadow: none;
    }
  }
  
  .risk-tabs {
    width: 100%;
    margin-bottom: 12px;

    .ant-tabs-nav-list {
      width: 100%;

      .ant-tabs-tab {
        flex: 1;
        display: flex;
        justify-content: center;
      }
    }
  }

  .mt-w {
    margin-top: var(--size-lg);
  }
  
  &.collapsed {
    .overflow-section {
      max-width: calc(100vw - 48px - 20px);
    }
    .overflow-section-2 {
      width: calc(100vw - 20px - 200px);
      overlow: auto;
    }
    .overflow-section-3 {
      width: calc(100vw - 20px - 200px);
      margin-right: auto;
      margin-left: auto;
      overlow: auto;
    }
  }

  &.not-collapsed {
    .overflow-section {
      max-width: calc(100vw - 48px - 250px - 20px);
    }

    .overflow-section-2 {
      width: calc(100vw - 20px - 250px - 130px);
      overlow: hidden;
    }
    .overflow-section-3 {
      width: calc(100vw - 20px - 250px - 120px);
      overlow: hidden;
      margin-left: auto;
      margin-right: auto;
    }
  }

  section {
    display: flex;
    flex-wrap: wrap;
    gap: var(--size-lg);
    margin-bottom: var(--size-lg);
    margin-top: 0px;

    &:last-of-type {
      margin-bottom: 0px;
    }

    &.no-wrap-section {
      flex-wrap: nowrap;
      overflow: hidden;
    }
  }

  .ant-page-header {
    box-shadow: 1px 4px 12px rgba(0, 0, 0, 0.12);
  }

  overflow-x: hidden;

  .risk-widget-container {
  }

  .analysis-container {
    min-height: 764px;
    flex: 1;
    display: flex;
    flex-direction: column;
    
    .view-full-analysis-btn {
      margin-top: 50px;
      width: 100%;
      border: 1px solid var(--color-primary-70);

      svg {
        margin-top: -5px;
      }
    }
  }
`;
